import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import { cpfMask, cnpjMask, cepMask, phoneMask } from "../../mask.js";
import axios from "axios";
import { replaceCaracEspeciais, validaCpfCnpj, validaEmail } from "../../utils";
import AsyncSelect from "react-select/async";

class NewClient extends Component {
  constructor() {
    super();
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.validarCliente = this.validarCliente.bind(this);
    this.cadastrarCliente = this.cadastrarCliente.bind(this);
    this.getDefaultCliente = this.getDefaultCliente.bind(this);
    this.loadDataStorage = this.loadDataStorage.bind(this);
    this.buscaCnpj = this.buscaCnpj.bind(this);
    this.buscaEmpresas = this.buscaEmpresas.bind(this);
    this.buscarEndereco = this.buscarEndereco.bind(this);
    this.onChangeEmpresa = this.onChangeEmpresa.bind(this);
    this.validarEndereco = this.validarEndereco.bind(this);
    this.salvarEndereco = this.salvarEndereco.bind(this);
    this.handleChangeInputNovoEndereco =
      this.handleChangeInputNovoEndereco.bind(this);
    this.adicionarEnderecos = this.adicionarEnderecos.bind(this);
    this.adicionarContato = this.adicionarContato.bind(this);
    this.salvarContato = this.salvarContato.bind(this);
    this.removeContato = this.removeContato.bind(this);
    this.removeEndereco = this.removeEndereco.bind(this);
    this.validarContato = this.validarContato.bind(this);
    this.promiseOptionsCondPgto = this.promiseOptionsCondPgto.bind(this);
    this.promiseOptionsformaPagto = this.promiseOptionsformaPagto.bind(this);
    this.promiseOptionsTransportadora =
      this.promiseOptionsTransportadora.bind(this);
    this.gravarCliente = this.gravarCliente.bind(this);
    this.loadUsuario = this.loadUsuario.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.consultaClienteCNPJ = this.consultaClienteCNPJ.bind(this);
    this.pastNewPage = this.pastNewPage.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);

    this.state = {
      cliente: this.getDefaultCliente(),
      errors: {
        desc: false,
        cnpjCpf: false,
        fantasia: false,
        ieRg: false,
      },
      db: null,
      exibirLoading: false,
      cnpjCpfValido: false,
      empresas: [],
      codEmpresa: null,
      novoEndereco: this.getDefaultEndereco(true),
      errorsEndereco: {
        cep: false,
        bairro: false,
        cep: false,
        cidade: false,
        endereco: false,
        estado: false,
        numero: false,
      },
      enderecos: [],
      novoContato: this.getDefaultContato(true),
      errorsContato: {
        desc: false,
        email: false,
        fone: false,
      },
      condPagto: null,
      formaPagto: null,
      transportadora: null,
      regimeTributario: null,
      validacao: { cliente: false, endereco: false, contato: false },
      contatos: [],
      obs: "",
    };
  }

  async componentDidMount() {
    //  await this.loadDataStorage();
    await this.buscaEmpresas();
    await this.loadUsuario();
    await this.verificaAutenticacao();
  }

  iniciarEndereco() {
    let data = localStorage.getItem("clienteNovo");

    if (data !== null) {
      data = JSON.parse(data);
      if (data.clienteNovo && data.clienteNovo.enderecos !== undefined) {
        if (data.clienteNovo.enderecos.length) {
          let enderecos = data.clienteNovo.enderecos;
          this.setState({ enderecos });
        }
      }

      if (data.novoEndereco !== undefined) {
        this.setState({ novoEndereco: data.novoEndereco });
      }
    }
  }

  iniciarContato() {
    let data = localStorage.getItem("clienteNovo");
    if (data !== null) {
      data = JSON.parse(data);
      if (data.clienteNovo.contatos !== undefined) {
        if (data.clienteNovo.contatos.length) {
          let contatos = data.clienteNovo.contatos;
          this.setState({ contatos });
        }
      }

      if (data.novoContato !== undefined) {
        this.setState({
          novoContato: {
            ...this.state.novoContato,
            fone: data.novoContato.fone,
            email: data.novoContato.email,
          },
        });
      }
    }
  }

  promiseOptionsCondPgto(inputValue) {
    return new Promise((resolve) => {
      let condicoesPagamento = [];
      setTimeout(async () => {
        await axios
          .get(
            `${this.props.getBaseUrlApi()}/clientes-novo/condPagto`,
            this.props.parameters()
          )
          .then((response) => {
            if (response.data.condPagto)
              condicoesPagamento = response.data.condPagto;
          })
          .catch((error) => {
            console.log(error);
            if (error.response !== undefined) {
              if (error.response.status === 401) {
                this.props.logout();
              }
              if (error.response.status === 403) {
                this.props.history.push('/home')
              }
            }
          })

        if (inputValue === "") {
          condicoesPagamento = this.transformDataComboBox(condicoesPagamento);
          condicoesPagamento.unshift({
            value: "INDEFINIDO",
            label: "INDEFINIDO",
          });

          this.setState({ condicoesPagamento });

          resolve(condicoesPagamento);
        } else {
          let aux = [];
          for (let condPagto of condicoesPagamento) {
            if (condPagto.indexOf(inputValue) != -1) {
              aux.push(condPagto);
            }
          }
          condicoesPagamento = aux;
          condicoesPagamento = this.transformDataComboBox(condicoesPagamento);
          this.setState({ condicoesPagamento });
          resolve(condicoesPagamento);
        }
      }, 100);
    });
  }

  promiseOptionsformaPagto(inputValue) {
    return new Promise((resolve) => {
      let formaPagamento = [];
      setTimeout(async () => {
        await axios
          .get(
            `${this.props.getBaseUrlApi()}/clientes-novo/formaPagto`,
            this.props.parameters()
          )
          .then((response) => {
            if (response.data.formaPagto)
              formaPagamento = response.data.formaPagto;
          })
          .catch((error) => {
            console.log(error);
            if (error.response !== undefined) {
              if (error.response.status === 401) {
                this.props.logout();
              }
              if (error.response.status === 403) {
                this.props.history.push('/home')
              }
            }
          })
        if (inputValue === "") {
          formaPagamento = this.transformDataComboBox(formaPagamento);
          formaPagamento.unshift({
            value: "INDEFINIDO",
            label: "INDEFINIDO",
          });

          this.setState({ formaPagamento });

          resolve(formaPagamento);
        } else {
          let aux = [];
          for (let formPagto of formaPagamento) {
            if (formPagto.indexOf(inputValue) != -1) {
              aux.push(formPagto);
            }
          }
          formaPagamento = aux;
          formaPagamento = this.transformDataComboBox(formaPagamento);
          this.setState({ formaPagamento });
          resolve(formaPagamento);
        }
      }, 100);
    });
  }

  promiseOptionsTransportadora(inputValue) {
    return new Promise((resolve) => {
      let transportadoras = [];
      setTimeout(async () => {
        await axios
          .get(
            `${this.props.getBaseUrlApi()}/clientes-novo/transportadora`,
            this.props.parameters()
          )
          .then((response) => {
            if (response.data.transport)
              transportadoras = response.data.transport;
          })
          .catch((error) => {
            console.log(error);
            if (error.response !== undefined) {
              if (error.response.status === 401) {
                this.props.logout();
              }
              if (error.response.status === 403) {
                this.props.history.push('/home')
              }
            }
          })
        if (inputValue === "") {
          transportadoras = this.transformDataComboBox(transportadoras);
          transportadoras.unshift({
            value: "INDEFINIDO",
            label: "INDEFINIDO",
          });

          this.setState({ transportadoras });

          resolve(transportadoras);
        } else {
          let aux = [];
          for (let transport of transportadoras) {
            if (transport.indexOf(inputValue) != -1) {
              aux.push(transport);
            }
          }
          transportadoras = aux;
          transportadoras = this.transformDataComboBox(transportadoras);
          this.setState({ transportadoras });
          resolve(transportadoras);
        }
      }, 100);
    });
  }

  transformDataComboBox(lista) {
    lista = lista.map((item) => {
      item.value = item.desc;
      item.label = item.desc;
      return item;
    });
    return lista;
  }

  getDefaultEndereco(sl) {
    return {
      idIntegracao: null,
      endereco: "",
      bairro: "",
      cidade: "",
      estado: "",
      cep: "",
      numero: "",
      complemento: "",
      principal: sl,
    };
  }

  getDefaultCliente() {
    return {
      _id: null,
      idIntegracao: null,
      tipoPessoa: "PF",
      desc: "",
      cnpjCpf: "",
      fantasia: "",
      ieRg: "",
      status: "A",
      type: "cliente",
      sincIntegracao: false,
    };
  }

  getDefaultContato(sl) {
    return {
      idIntegracao: null,
      desc: "",
      email: "",
      fone: "",
      cel: "",
      padrao: sl,
      status: "A",
    };
  }

  async handleChangeInput(e, tipo) {
    let value = e.target.value;
    let tipoPessoa = this.state.cliente.tipoPessoa;
    if (tipo === "cnpjCpf") {
      if (value.length > 14) {
        value = cnpjMask(value);
        tipoPessoa = "PJ";
      } else {
        value = cpfMask(value);
        tipoPessoa = "PF";
      }
    }
    if (tipo == "ieRg") {
      value = value.toUpperCase();
    }
    if (tipo == "fantasia") value = value.toUpperCase();

    if (tipo == "desc") {
      if (value.length) {
        let valid = await this.checkChar(value);
        if (!valid) {
          e.preventDefault();
          return false;
        }
      }
    }

    this.setState({
      cliente: { ...this.state.cliente, [tipo]: value, tipoPessoa: tipoPessoa },
    });
    let vl = this.validarCliente();
    if (vl) {
      this.cadastrarCliente();
    }
  }

  handleChangeInputNovoEndereco(e, tipo) {
    let value = e.target.value;

    if (tipo === "cep") {
      value = cepMask(value);
    }

    this.setState({
      novoEndereco: { ...this.state.novoEndereco, [tipo]: value },
    });
  }

  handleChangeInputObs(e, tipo) {
    let value = e.target.value;
    this.setState({ obs: value });
  }

  handleChangeInputNovoContato(e, tipo) {
    let value = e.target.value;
    if (tipo === "fone") {
      value = phoneMask(value);
    }

    if (tipo === "cel") {
      value = phoneMask(value);
    }
    if (tipo === "desc") {
      value = value.toUpperCase();
    }

    this.setState({
      novoContato: { ...this.state.novoContato, [tipo]: value },
    });
  }

  async handleChangeSelect(item, tipo) {
    if (item.value === "INDEFINIDO") {
      item = null;
    }
    this.setState({ [tipo]: item });
  }

  async checkChar(e) {
    //let char = String.fromCharCode(e.keyCode);
    let char = e;
    let pattern = "[a-zA-Z0-9]";
    if (char.match(pattern) /*|| char.indexOf("\'") !== -1*/) {
      return true;
    } /*else {
      return false;
    }*/
  }

  async pastNewPage(e) {
    if (e.which == 9) {
      this.avancarAba("cliente");
    }
  }

  async consultaClienteCNPJ(e, type) {
    if (e.which == 13) {
      this.buscaCnpj();
    }
  }

  validarCliente() {
    let errorsLocal = this.state.errors;
    let cliente = this.state.cliente;
    let valido = true;
    if (cliente.cnpjCpf === "") {
      errorsLocal.cnpjCpf = true;
      valido = false;
    } else {
      errorsLocal.cnpjCpf = false;
    }

    if (cliente.desc === "") {
      errorsLocal.desc = true;
      valido = false;
    } else {
      errorsLocal.desc = false;
    }

    if (cliente.tipoPessoa === "PJ") {
      if (cliente.fantasia === "") {
        errorsLocal.fantasia = true;
        valido = false;
      } else {
        errorsLocal.fantasia = false;
      }
    }

    if (cliente.ieRg === "") {
      errorsLocal.ieRg = true;
      valido = false;
    } else {
      errorsLocal.ieRg = false;
    }
    this.setState({ errors: errorsLocal });
    return valido;
  }

  validarContato() {
    let errorsLocal = this.state.errorsContato;
    let contato = this.state.novoContato;
    let camposObrigatorios = ["email", "fone"];

    if (this.state.cliente.tipoPessoa === "PJ") {
      camposObrigatorios.push("desc");
    }

    let valido = true;

    for (let campo of camposObrigatorios) {
      if (contato[campo] === "") {
        errorsLocal[campo] = true;
        valido = false;
      } else {
        errorsLocal[campo] = false;
      }
    }

    this.setState({ errorsContato: errorsLocal });
    return valido;
  }

  validarEndereco() {
    let errorsLocal = this.state.errorsEndereco;
    let endereco = this.state.novoEndereco;
    let camposObrigatorios = [
      "bairro",
      "cep",
      "cidade",
      "endereco",
      "estado",
      "numero",
    ];

    let valido = true;

    for (let campo of camposObrigatorios) {
      if (endereco[campo] === "") {
        errorsLocal[campo] = true;
        valido = false;
      } else {
        errorsLocal[campo] = false;
      }
    }

    this.setState({ errorsEndereco: errorsLocal });
    return valido;
  }

  async avancarAba(tela) {
    let end = this.state.enderecos;
    let con = this.state.contatos;
    let ret = await this.validarCliente();
    if (tela == "cliente") {
      if (end.length === 0) this.iniciarEndereco();
      if (ret) {
        document.getElementById("li-cliente").classList.add("visited");
      } else {
        document.getElementById("li-cliente").classList.add("actention");
      }
      document.getElementById("li-endereco").classList.remove("actention");
      document.getElementById("tab-cliente").classList.remove("active");
      document.getElementById("li-endereco").classList.add("active");
      document.getElementById("tab-endereco").classList.add("active");
      document.getElementById("li-contato").classList.remove("active");
      document.getElementById("tab-contato").classList.remove("active");
      document.getElementById("li-contato").classList.remove("visited");
      document.getElementById("tab-info").classList.remove("active");
      document.getElementById("tab-info").classList.remove("visited");
      document.getElementById("li-info").classList.remove("visited");
      document.getElementById("li-info").classList.remove("active");
    }
    if (tela == "endereco") {
      //this.iniciarContato();
      document.getElementById("tab-cliente").classList.remove("active");
      if (end.length)
        document.getElementById("li-endereco").classList.add("visited");
      else document.getElementById("li-endereco").classList.add("actention");
      document.getElementById("li-contato").classList.remove("actention");
      document.getElementById("li-endereco").classList.remove("active");
      document.getElementById("li-contato").classList.add("active");
      document.getElementById("li-contato").classList.remove("visited");
      document.getElementById("tab-endereco").classList.remove("active");
      document.getElementById("tab-contato").classList.add("active");
      document.getElementById("li-info").classList.remove("active");
      document.getElementById("tab-info").classList.remove("active");
      if (ret) {
        document.getElementById("li-cliente").classList.add("visited");
      } else {
        document.getElementById("li-cliente").classList.add("actention");
      }
    }
    if (tela == "contato") {
      document.getElementById("tab-cliente").classList.remove("active");
      if (end.length)
        document.getElementById("li-endereco").classList.add("visited");
      else document.getElementById("li-endereco").classList.add("actention");
      if (con.length)
        document.getElementById("li-contato").classList.add("visited");
      else document.getElementById("li-contato").classList.add("actention");
      document.getElementById("li-contato").classList.remove("active");
      document.getElementById("li-info").classList.add("active");
      document.getElementById("tab-contato").classList.remove("active");
      document.getElementById("tab-info").classList.add("active");
      if (ret) {
        document.getElementById("li-cliente").classList.add("visited");
      } else {
        document.getElementById("li-cliente").classList.add("actention");
      }
    }
    if (tela == "cli-cliente") {
      document.getElementById("tab-cliente").classList.add("active");
      document.getElementById("li-info").classList.remove("active");
      document.getElementById("tab-info").classList.remove("active");
      document.getElementById("li-contato").classList.remove("active");
      document.getElementById("tab-contato").classList.remove("active");
      document.getElementById("li-contato").classList.remove("visited");
      document.getElementById("tab-contato").classList.remove("visited");
      document.getElementById("li-endereco").classList.remove("active");
      document.getElementById("tab-endereco").classList.remove("active");
      document.getElementById("li-endereco").classList.remove("visited");
      document.getElementById("tab-endereco").classList.remove("visited");
      document.getElementById("li-cliente").classList.remove("actention");
      document.getElementById("li-contato").classList.remove("actention");
      document.getElementById("li-endereco").classList.remove("actention");
    }
  }

  async voltarAba(tela) {
    if (tela == "endereco") {
      document.getElementById("li-endereco").classList.remove("active");
      document.getElementById("li-cliente").classList.remove("visited");
      document.getElementById("li-cliente").classList.add("active");
      document.getElementById("tab-endereco").classList.remove("active");
      document.getElementById("tab-cliente").classList.add("active");
    }
    if (tela == "contato") {
      document.getElementById("li-endereco").classList.remove("visited");
      document.getElementById("li-contato").classList.remove("active");
      document.getElementById("li-endereco").classList.add("active");
      document.getElementById("tab-contato").classList.remove("active");
      document.getElementById("tab-endereco").classList.add("active");
    }
    if (tela == "info") {
      document.getElementById("li-contato").classList.remove("visited");
      document.getElementById("li-info").classList.remove("active");
      document.getElementById("li-contato").classList.add("active");
      document.getElementById("tab-info").classList.remove("active");
      document.getElementById("tab-contato").classList.add("active");
    }
  }

  async cadastrarCliente() {
    /*if (!this.validarCliente()) {
      this.notificar(
        "warning",
        "Favor preencher todos os campos corretamente!"
      );
      return false;
    }*/

    let cliente = this.state.cliente;
    if (!validaCpfCnpj(cliente.cnpjCpf)) {
      if (cliente.tipoPessoa === "PJ") {
        this.notificar("warning", "CNPJ inválido.");
      } else {
        this.notificar("warning", "CPF inválido.");
      }
      return false;
    }

    if (cliente.tipoPessoa === "PJ" && !this.state.cnpjCpfValido) {
      this.notificar("warning", "Cliente já cadastrado com este CNPJ!");
      return false;
    } else {
      //localStorage.removeItem("clienteNovo");
    }

    if (cliente.fantasia !== "") {
      cliente.descFormat = `${cliente.fantasia} - ${cliente.desc}`;
    } else {
      cliente.descFormat = cliente.desc;
    }

    cliente.descFormat = replaceCaracEspeciais(cliente.descFormat);
    cliente.descFormat = cliente.descFormat.toUpperCase();
    cliente.cod = "NOVO";

    let dados = localStorage.getItem("clienteNovo");
    if (dados !== null) {
      dados = JSON.parse(dados);
      if (dados.clienteNovo !== undefined) {
        if (dados.clienteNovo.contatos !== undefined) {
          cliente.contatos = dados.clienteNovo.contatos;
        }

        if (dados.clienteNovo.enderecos !== undefined) {
          cliente.enderecos = dados.clienteNovo.enderecos;
        }
      }
    } else {
      dados = {};
    }

    dados.clienteNovo = cliente;
    dados.validacao = {
      cliente: true,
    };

    dados.codEmpresa = this.state.codEmpresa;
    let val = this.state.validacao;
    this.setState({
      validacao: {
        cliente: true,
        contato: val.contato,
        endereco: val.endereco,
      },
    });
    //  localStorage.setItem("clienteNovo", JSON.stringify(dados));
    //this.notificar("success", "Cliente cadastrado com sucesso!");
    //  this.avancarAba("cliente");
  }

  adicionarEnderecos() {
    let enderecos = this.state.enderecos;
    if (enderecos.length === 0) {
      this.notificar("warning", "Adicione pelo menos 1 endereço");
      return false;
    }

    let data = localStorage.getItem("clienteNovo");
    data = JSON.parse(data);
    let clienteNovo = data.clienteNovo;

    clienteNovo.enderecos = enderecos;

    let dados = {
      clienteNovo: clienteNovo,
      validacao: {
        cliente: true,
        endereco: true,
      },
      //codEmpresa: data.codEmpresa,
    };

    if (data.novoContato !== undefined) {
      dados.novoContato = data.novoContato;
    }

    localStorage.setItem("clienteNovo", JSON.stringify(dados));
    this.avancarAba("endereco");
  }

  adicionarContato() {
    let contatos = this.state.contatos;

    /*if (contatos.length === 0) {
      this.notificar("warning", "Adicione pelo menos 1 contato");
      return false;
    }*/

    let clienteNovo = localStorage.getItem("clienteNovo");
    clienteNovo = JSON.parse(clienteNovo);
    let codEmpresa = this.state.codEmpresa;
    clienteNovo = this.state.cliente;

    clienteNovo.contatos = contatos;
    let dados = {
      clienteNovo: clienteNovo,
      validacao: {
        cliente: true,
        endereco: true,
        contato: true,
      },
      codEmpresa,
    };

    localStorage.setItem("clienteNovo", JSON.stringify(dados));
    //this.props.history.push("/clientes/novo/info");
    // this.avancarAba("contato");
  }

  salvarEndereco() {
    let enderecos = this.state.enderecos;
    let novoEndereco = this.state.novoEndereco;
    if (!this.validarEndereco()) {
      this.notificar(
        "warning",
        "Favor preencher todos os campos corretamente!"
      );
      return false;
    }

    if (enderecos.length && novoEndereco.principal) {
      for (let endereco of enderecos) {
        if (endereco.principal) {
          endereco.principal = false;
        }
      }
    }

    novoEndereco.sequencia = 0;

    if (enderecos.length) {
      novoEndereco.sequencia = enderecos[enderecos.length - 1].sequencia + 1;
    }

    enderecos.push(novoEndereco);
    let val = this.state.validacao;

    this.setState(
      {
        enderecos,
        validacao: {
          endereco: true,
          cliente: val.cliente,
          contato: val.contato,
        },
      },
      () => {
        this.setState({ novoEndereco: this.getDefaultEndereco(false) });
        this.notificar("success", "Endereço cadastrado com sucesso");
        //this.toggleAba("listaEnderecos");
      }
    );
  }

  salvarContato() {
    let contatos = this.state.contatos;
    let novoContato = this.state.novoContato;
    if (!this.validarContato()) {
      this.notificar(
        "warning",
        "Favor preencher todos os campos corretamente!"
      );
      return false;
    }

    if (contatos.length && novoContato.padrao) {
      for (let contato of contatos) {
        if (contato.padrao) {
          contato.padrao = false;
        }
      }
    }

    novoContato.sequencia = 0;

    if (contatos.length) {
      novoContato.sequencia = contatos[contatos.length - 1].sequencia + 1;
    }

    if (this.state.cliente.tipoPessoa === "PF") {
      novoContato.desc = this.state.cliente.desc;
    }
    contatos.push(novoContato);
    let val = this.state.validacao;
    this.setState(
      {
        contatos,
        validacao: {
          contato: true,
          endereco: val.endereco,
          cliente: val.cliente,
        },
      },
      () => {
        this.setState({ novoContato: this.getDefaultContato(false) });
        this.notificar("success", "Contato cadastrado com sucesso");
        //  this.salvarContato()
        // this.toggleAba("listaContatos");
      }
    );
  }

  removeContato(sequencia) {
    let contatos = this.state.contatos;
    contatos = contatos.filter((cont) => cont.sequencia !== sequencia);

    for (let i = 0; i < contatos.length; i++) {
      contatos[i].sequencia = i;
    }
    let val = this.state.validacao;
    if (contatos.length === 0)
      this.setState({
        contatos,
        validacao: {
          contato: false,
          endereco: val.endereco,
          cliente: val.cliente,
        },
      });
    else this.setState({ contatos });
  }

  removeEndereco(sequencia) {
    // localStorage.removeItem("clienteNovo");
    let enderecos = this.state.enderecos;
    enderecos = enderecos.filter((end) => end.sequencia !== sequencia);

    for (let i = 0; i < enderecos.length; i++) {
      enderecos[i].sequencia = i;
    }
    let val = this.state.validacao;
    if (enderecos.length === 0)
      this.setState({
        enderecos,
        validacao: {
          contato: val.contato,
          endereco: false,
          cliente: val.cliente,
        },
      });
    else this.setState({ enderecos });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  loadDataStorage() {
    let data = localStorage.getItem("clienteNovo");
    localStorage.removeItem("clienteNovo");
    if (data !== null) {
      data = JSON.parse(data);
      let cliente = this.state.cliente;
      cliente.tipoPessoa = data.clienteNovo.tipoPessoa;
      cliente.desc = data.clienteNovo.desc;
      cliente.cnpjCpf = data.clienteNovo.cnpjCpf;
      cliente.fantasia = data.clienteNovo.fantasia;
      cliente.ieRg = data.clienteNovo.ieRg;

      this.setState({ cliente, codEmpresa: data.codEmpresa });
    }
  }

  async loadUsuario() {
    let usuario = {};
    await axios
      .get(`${this.props.getBaseUrlApi()}/clientes-novo/usuarios`, this.props.parameters())
      .then((response) => {
        usuario = response.data;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
    this.setState({ usuario: usuario });
  }

  async buscaCnpj() {
    let cliente = this.state.cliente;
    this.setState({
      errors: { ...this.state.errors, cnpjCpf: false },
      cnpjCpfValido: false,
    });

    if (cliente.tipoPessoa === "PF") {
      return null;
    }

    if (!navigator.onLine) {
      this.notificar(
        "warning",
        "Conecte a uma rede de dados para buscar informações do CNPJ!"
      );
      return false;
    }

    this.setState({ exibirLoading: true }, async () => {
      await axios
        .post(
          `${this.props.getBaseUrlApi()}/clientes-novo/consultaCnpj`,
          { cnpj: this.state.cliente.cnpjCpf },
          this.props.parameters()
        )
        .then((response) => {
          if (response.data == "cnpj não está no cache") {
            this.setState({ cnpjCpfValido: true });
          } else {
            let cliente = response.data;
            let clienteState = this.state.cliente;
            clienteState.desc = cliente.desc;
            clienteState.fantasia = cliente.fantasia;
            this.setState(
              {
                cliente: clienteState,
                exibirLoading: false,
                cnpjCpfValido: true,
                novoContato: {
                  ...this.state.novoContato,
                  fone: cliente.contato.fone,
                  email: cliente.contato.email,
                },
              },
              () => {
                let data = JSON.parse(localStorage.getItem("clienteNovo"));
                if (data === null) {
                  data = {};
                }

                data.novoEndereco = {
                  ...cliente.endereco,
                  principal: true,
                  sequencia: 0,
                };

                data.novoContato = {
                  ...cliente.contato,
                };
                localStorage.setItem("clienteNovo", JSON.stringify(data));
              }
            );
          }
        })
        .catch((error) => {
          this.notificar("error", error.response.data.erro.msg);
          this.setState({
            exibirLoading: false,
            errors: { ...this.state.errors, cnpjCpf: true },
            cnpjCpfValido: false,
          });
          if (error.response !== undefined) {
            if (error.response.status === 401) {
              this.props.logout();
            }
            if (error.response.status === 403) {
              this.props.history.push('/home')
            }
          }
        });
    });
  }

  async buscarEndereco() {
    let cep = this.state.novoEndereco.cep;

    if (cep === "") return false;

    cep = cep.replace(".", "");
    cep = cep.replace("-", "");

    if (cep.length < 8) {
      this.notificar("warning", "Cep digitado é inválido");
      return false;
    }

    if (!navigator.onLine) {
      this.notificar(
        "warning",
        "Conecte a uma rede de dados para buscar informações do CEP!"
      );
      return false;
    }

    this.setState({ exibirLoading: true }, async () => {
      await axios
        .get(`https://viacep.com.br/ws/${cep}/json`)
        .then((response) => {
          let data = response.data;

          if (data.erro) {
            this.notificar(
              "warning",
              "Não foi possível localizar informação com base no CEP digitado!"
            );
            this.setState({ exibirLoading: false });
            return false;
          }

          let novoEndereco = this.state.novoEndereco;
          novoEndereco.endereco = data.logradouro;
          novoEndereco.bairro = data.bairro;
          novoEndereco.cidade = data.localidade;
          novoEndereco.estado = data.uf;

          this.setState({ novoEndereco, exibirLoading: false });
        })
        .catch((error) => {
          this.notificar(
            "warning",
            "Ocorreu um erro ao tentar buscar as informações."
          );
          this.setState({ exibirLoading: false });
        });
    });
  }

  async buscaEmpresas() {
    localStorage.removeItem("clienteNovo");
    let empresas;
    let idUsuario = localStorage.getItem('idUsuario');
    await axios
      .get(`${this.props.getBaseUrlApi()}/clientes-novo/empresas?idusuario=${idUsuario}`, this.props.parameters())
      .then((response) => {
        if (response.data.empresas) empresas = response.data.empresas;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
    let codEmpresa = this.state.codEmpresa;
    if (codEmpresa === null) {
      codEmpresa = empresas[0].idIntegracao;
    }
    this.setState({ empresas, codEmpresa });
  }

  onChangeEmpresa(e) {
    this.setState({ codEmpresa: e.target.value });
  }

  async gravarCliente() {
    let condPagto = this.state.condPagto;
    let formaPagto = this.state.formaPagto;
    let transportadora = this.state.transportadora;
    let regimeTributario = this.state.regimeTributario;
    let obs = this.state.obs;
    let usuario = this.state.usuario;
    //console.log(localStorage.getItem("clienteNovo"))
    //let clienteNovo = localStorage.getItem("clienteNovo");
    let clienteNovo = this.state.cliente;
    let codEmpresa = this.state.codEmpresa;
    clienteNovo.enderecos = this.state.enderecos;
    clienteNovo.contatos = this.state.contatos;
    //  clienteNovo = clienteNovo.clienteNovo;
    if (condPagto !== null) {
      clienteNovo.condPagto = {
        idIntegracao: condPagto.idIntegracao,
        desc: condPagto.desc,
        pDesc: condPagto.pDesc,
      };
    } else {
      clienteNovo.condPagto = null;
    }

    if (formaPagto !== null) {
      clienteNovo.formaPagto = {
        idIntegracao: formaPagto.idIntegracao,
        desc: formaPagto.desc,
      };
    } else {
      clienteNovo.formaPagto = null;
    }

    if (transportadora !== null) {
      clienteNovo.transportadora = {
        idIntegracao: transportadora.idIntegracao,
        desc: transportadora.desc,
      };
    } else {
      clienteNovo.transportadora = null;
    }

    if (usuario !== null) {
      let vendedor = usuario.vendedores.find(
        (vend) => vend.idEmpresa === codEmpresa
      );
      clienteNovo.vendedor = {
        idIntegracao: vendedor.idIntegracao,
      };
    } else {
      clienteNovo.vendedor = null;
    }

    if (clienteNovo.tipoPessoa === "PF") {
      clienteNovo.regimeTributario = "Indefinido";
    } else {
      clienteNovo.regimeTributario = regimeTributario;
    }

    clienteNovo.obs = obs;

    //DEFINE ENDEREÇO E CONTATO PADRÃO
    let contatoPadrao = clienteNovo.contatos.find((i) => i.padrao === true);
    let enderecoPrincipal = clienteNovo.enderecos.find(
      (i) => i.principal === true
    );

    if (contatoPadrao === undefined) {
      clienteNovo.contatos[0].padrao = true;
    }
    if (enderecoPrincipal === undefined) {
      clienteNovo.enderecos[0].principal = true;
    }

    let status = "";
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/clientes-novo/salvarCliente`,
        { cliente: clienteNovo },
        this.props.parameters()
      )
      .then((response) => {
        status = response.statusText;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
    if (status == "OK") {
      localStorage.removeItem("clienteNovo");
      this.notificar("success", "Cliente gravado com sucesso!");
      setTimeout(() => {
        document.location.reload(true);
      }, 500);
    } else {
      this.notificar("error", "Erro ao gravar o cliente!");
    }
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }


  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Novo Cliente" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"newClient"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Novo Cliente"
                  description="Adicionar novo cliente"
                /> */}
                <div>
                  <ul
                    id="alterUl"
                    className="nav nav-tabs justify-content-center process-model more-icon-preocess"
                    role="tablist"
                    style={{ marginTop: "-0.1%" }}
                  >
                    <li id="li-cliente" role="presentation" className="active">
                      <a
                        href="#discover"
                        aria-controls="discover"
                        role="tab"
                        data-toggle="tab"
                        onClick={() => this.avancarAba("cli-cliente")}
                      >
                        <i className="fa fa-user-plus" aria-hidden="true"></i>
                        <p>Cliente</p>
                      </a>
                    </li>
                    <li id="li-endereco" role="presentation">
                      <a
                        href="#strategy"
                        aria-controls="strategy"
                        role="tab"
                        data-toggle="tab"
                        onClick={() => this.avancarAba("cliente")}
                      >
                        <i className="fa fa-map-o" aria-hidden="true"></i>
                        <p>Endereços</p>
                      </a>
                    </li>
                    <li id="li-contato" role="presentation">
                      <a
                        href="#optimization"
                        aria-controls="optimization"
                        role="tab"
                        data-toggle="tab"
                        onClick={() => this.avancarAba("endereco")}
                      >
                        <i className="fa fa-users" aria-hidden="true"></i>
                        <p>Contatos</p>
                      </a>
                    </li>
                    <li id="li-info" role="presentation">
                      <a
                        href="#content"
                        aria-controls="content"
                        role="tab"
                        data-toggle="tab"
                        onClick={() => this.avancarAba("contato")}
                      >
                        <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                        <p>Info adicionais</p>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="container">
                  <div className="card">
                    <div className="col-xs-12">
                      <div className="tab-content">
                        <div
                          role="tabpanel"
                          className="tab-pane active"
                          id="tab-cliente"
                        >
                          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Tab de novos Clientes <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/}
                          <div
                            className=" width-100"
                            style={{ padding: "15px" }}
                          >
                            <div
                              className="container"
                              style={{ fontSize: "13.5px" }}
                            >
                              <div
                                className="row"
                                style={{
                                  position: "relative",
                                }}
                              >
                                <div
                                  className="form-group pd-pedido"
                                  style={{ width: "20%" }}
                                >
                                  <label>CPF/CNPJ</label>
                                  <input
                                    type="text"
                                    value={this.state.cliente.cnpjCpf}
                                    onChange={(e) =>
                                      this.handleChangeInput(e, "cnpjCpf")
                                    }
                                    onKeyDown={(e) => {
                                      this.consultaClienteCNPJ(e, "cliente");
                                    }}
                                    className={`form-control font-size-13 ${
                                      this.state.errors.cnpjCpf
                                        ? "input-error"
                                        : ""
                                    }`}
                                    onBlur={(e) => {
                                      if (
                                        !validaCpfCnpj(
                                          this.state.cliente.cnpjCpf
                                        )
                                      ) {
                                        if (
                                          this.state.cliente.tipoPessoa === "PJ"
                                        ) {
                                          this.notificar(
                                            "warning",
                                            "CNPJ inválido."
                                          );
                                        } else {
                                          this.notificar(
                                            "warning",
                                            "CPF inválido."
                                          );
                                        }
                                        this.setState({
                                          errors: {
                                            ...this.state.errors,
                                            cnpjCpf: true,
                                          },
                                        });
                                      } else {
                                        this.buscaCnpj();
                                      }
                                    }}
                                  />
                                </div>
                                <div
                                  className="form-group pd-pedido"
                                  style={{ width: "20%" }}
                                >
                                  <label>
                                    {this.state.cliente.tipoPessoa === "PJ"
                                      ? "Insc. Estadual"
                                      : "RG"}
                                  </label>
                                  <input
                                    value={this.state.cliente.ieRg}
                                    onChange={(e) =>
                                      this.handleChangeInput(e, "ieRg")
                                    }
                                    className={`form-control font-size-13 `}
                                    onBlur={(e) =>
                                      this.handleChangeInput(e, "ieRg")
                                    }
                                  />
                                </div>
                                <div className="form-group col-6 pd-pedido">
                                  <label>
                                    {this.state.cliente.tipoPessoa === "PJ"
                                      ? "Razão Social"
                                      : "Nome"}
                                  </label>
                                  <input
                                    type="text"
                                    value={this.state.cliente.desc}
                                    onChange={(e) =>
                                      this.handleChangeInput(e, "desc")
                                    }
                                    className={`form-control font-size-13`}
                                  />
                                </div>
                                {/* <div
                                  style={{
                                    position: "absolute",
                                    right: "45px",
                                    top: "28px",
                                  }}
                                >
                                  {this.state.exibirLoading && (
                                    <div
                                      id="loading-bar-spinner2"
                                      className="spinner"
                                    >
                                      <div className="spinner-icon"></div>
                                    </div>
                                  )}
                                </div> */}
                              </div>

                              <div className="row">
                                <div className="form-group col-5 pd-pedido">
                                  <label>Empresa</label>
                                  <select
                                    className="form-control"
                                    value={this.state.codEmpresa}
                                    onChange={this.onChangeEmpresa}
                                    onKeyDown={(e) => {
                                      if (this.state.cliente.tipoPessoa != "PJ")
                                        this.pastNewPage(e);
                                    }}
                                  >
                                    {this.state.empresas.map((empresa, key) => (
                                      <option
                                        key={key}
                                        value={empresa.idIntegracao}
                                      >
                                        {empresa.idIntegracao} -{" "}
                                        {empresa.fantasia}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {this.state.cliente.tipoPessoa === "PJ" && (
                                  <div className="form-group col-5 pd-pedido">
                                    <label>Fantasia</label>
                                    <input
                                      type="text"
                                      value={this.state.cliente.fantasia}
                                      onChange={(e) =>
                                        this.handleChangeInput(e, "fantasia")
                                      }
                                      onKeyDown={(e) => {
                                        this.pastNewPage(e);
                                      }}
                                      className={`form-control font-size-13 `}
                                    />
                                  </div>
                                )}
                              </div>

                              {/*<div className="row">
                                <div className="form-group col-5 pd-pedido">
                                  <div style={{ margin: "5px" }}>
                                    <button
                                      className="btn btn-success btn-app-pedidos-verde"
                                      // onClick={() =>
                                      //   //this.cadastrarPedido("orcamento")
                                      // }
                                      onClick={this.cadastrarCliente}
                                    >
                                      Adicionar
                                    </button>
                                  </div>
                                </div>
                                    </div>*/}
                            </div>
                          </div>
                          <div className="col-12">
                            <button
                              id="btn-prox"
                              onClick={() => this.avancarAba("cliente")}
                              style={{ marginBottom: "1%", marginLeft: "0.3%" }}
                              className="btn btn-success pull-left"
                            >
                              Próximo
                            </button>
                          </div>
                        </div>
                        <div
                          role="tabpanel"
                          className="tab-pane"
                          id="tab-endereco"
                        >
                          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Tab de novos endereços <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/}
                          <React.Fragment>
                            <div
                              className="float-left width-100"
                              style={{ padding: "15px" }}
                            >
                              <div
                                className="container row"
                                style={{
                                  fontSize: "13.5px",
                                }}
                              >
                                <div className="col-2 float-left pd-pedido">
                                  <div className="form-group">
                                    <label>Tipo</label>
                                    <select
                                      className="form-control font-size-13"
                                      value={this.state.novoEndereco.principal}
                                      onChange={(e) =>
                                        this.setState({
                                          novoEndereco: {
                                            ...this.state.novoEndereco,
                                            principal:
                                              e.target.value === "true"
                                                ? true
                                                : false,
                                          },
                                        })
                                      }
                                    >
                                      <option value="true">Principal</option>
                                      <option value="false">Secundário</option>
                                    </select>
                                  </div>
                                </div>

                                <div
                                  className="float-left pd-pedido"
                                  style={{ width: "15%" }}
                                >
                                  <div
                                    className="form-group float-left"
                                    style={{ width: "100%" }}
                                  >
                                    <label>CEP</label>
                                    <input
                                      type="text"
                                      value={this.state.novoEndereco.cep}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoEndereco(
                                          e,
                                          "cep"
                                        )
                                      }
                                      className={`form-control font-size-13 ${
                                        this.state.errorsEndereco.cep
                                          ? "input-error"
                                          : ""
                                      }`}
                                      onBlur={this.buscarEndereco}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "45px",
                                      top: "28px",
                                    }}
                                  >
                                    {this.state.exibirLoading && (
                                      <div
                                        id="loading-bar-spinner2"
                                        className="spinner"
                                      >
                                        <div className="spinner-icon"></div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-4 float-left pd-pedido">
                                  <div className="form-group">
                                    <label>Rua</label>
                                    <input
                                      type="text"
                                      value={this.state.novoEndereco.endereco}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoEndereco(
                                          e,
                                          "endereco"
                                        )
                                      }
                                      className={`form-control font-size-13 ${
                                        this.state.errorsEndereco.endereco
                                          ? "input-error"
                                          : ""
                                      }`}
                                    />
                                  </div>
                                </div>

                                <div className="col-1 float-left pd-pedido">
                                  <div className="form-group">
                                    <label>Número</label>
                                    <input
                                      type="text"
                                      value={this.state.novoEndereco.numero}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoEndereco(
                                          e,
                                          "numero"
                                        )
                                      }
                                      className={`form-control font-size-13 ${
                                        this.state.errorsEndereco.numero
                                          ? "input-error"
                                          : ""
                                      }`}
                                    />
                                  </div>
                                </div>
                                <div className="form-group col-3 pd-pedido">
                                  <label>Bairro</label>
                                  <input
                                    type="text"
                                    value={this.state.novoEndereco.bairro}
                                    onChange={(e) =>
                                      this.handleChangeInputNovoEndereco(
                                        e,
                                        "bairro"
                                      )
                                    }
                                    className={`form-control font-size-13 ${
                                      this.state.errorsEndereco.bairro
                                        ? "input-error"
                                        : ""
                                    }`}
                                  />
                                </div>
                                <div className="col-2 float-left pd-pedido">
                                  <div className="form-group">
                                    <label>Cidade</label>
                                    <input
                                      type="text"
                                      value={this.state.novoEndereco.cidade}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoEndereco(
                                          e,
                                          "cidade"
                                        )
                                      }
                                      className={`form-control font-size-13 ${
                                        this.state.errorsEndereco.cidade
                                          ? "input-error"
                                          : ""
                                      }`}
                                    />
                                  </div>
                                </div>
                                <div className="col-1 float-left pd-pedido">
                                  <div className="form-group">
                                    <label>Estado</label>
                                    <select
                                      className={`form-control font-size-13 ${
                                        this.state.errorsEndereco.estado
                                          ? "input-error"
                                          : ""
                                      }`}
                                      value={this.state.novoEndereco.estado}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoEndereco(
                                          e,
                                          "estado"
                                        )
                                      }
                                    >
                                      <option value="">Selecione</option>
                                      <option value="AC">AC</option>
                                      <option value="AL">AL</option>
                                      <option value="AP">AP</option>
                                      <option value="AM">AM</option>
                                      <option value="BA">BA</option>
                                      <option value="CE">CE</option>
                                      <option value="DF">DF</option>
                                      <option value="ES">ES</option>
                                      <option value="GO">GO</option>
                                      <option value="MA">MA</option>
                                      <option value="MT">MT</option>
                                      <option value="MS">MS</option>
                                      <option value="MG">MG</option>
                                      <option value="PA">PA</option>
                                      <option value="PB">PB</option>
                                      <option value="PR">PR</option>
                                      <option value="PE">PE</option>
                                      <option value="PI">PI</option>
                                      <option value="RJ">RJ</option>
                                      <option value="RN">RN</option>
                                      <option value="RS">RS</option>
                                      <option value="RO">RO</option>
                                      <option value="RR">RR</option>
                                      <option value="SC">SC</option>
                                      <option value="SP">SP</option>
                                      <option value="SE">SE</option>
                                      <option value="TO">TO</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="form-group col-5 pd-pedido">
                                  <label>Complemento</label>
                                  <input
                                    type="text"
                                    value={this.state.novoEndereco.complemento}
                                    onChange={(e) =>
                                      this.handleChangeInputNovoEndereco(
                                        e,
                                        "complemento"
                                      )
                                    }
                                    className="form-control font-size-13"
                                  />
                                </div>
                                <div className="col-2 float-left pd-pedido">
                                  <div className="form-group">
                                    <button
                                      className="btn btn-success btn-app-pedidos-verde"
                                      style={{ marginTop: "30px" }}
                                      onClick={this.salvarEndereco}
                                    >
                                      Adicionar
                                    </button>
                                  </div>
                                </div>

                                {
                                  <div className="form-group col-12 pd-pedido">
                                    {/* <button
                                    className="btn btn-secondary"
                                    onClick={() => this.avancarAba("cli-cliente")}
                                    style={{ marginLeft: "-1%" }}
                                  >
                                    Voltar
                                  </button> */}
                                    <button
                                      className="btn btn-success"
                                      onClick={() =>
                                        this.avancarAba("endereco")
                                      }
                                      //style={{ marginLeft: "1%" }}
                                    >
                                      Próximo
                                    </button>
                                  </div>
                                }
                              </div>

                              <div
                                className="row"
                                style={{ padding: "0 15px" }}
                              >
                                <table className="table table-striped">
                                  <thead className="thead-dark">
                                    <tr>
                                      <th scope="col">CEP</th>
                                      <th scope="col">Tipo</th>
                                      <th scope="col">Rua</th>
                                      <th scope="col">Bairro</th>
                                      <th scope="col">Cidade</th>
                                      <th scope="col" className="text-center">
                                        Ações
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.enderecos.map(
                                      (endereco, key) => (
                                        <tr key={key}>
                                          <th scope="row">{endereco.cep}</th>
                                          <td>
                                            {endereco.principal
                                              ? "(Principal)"
                                              : "Secundário"}{" "}
                                          </td>
                                          <td>
                                            {endereco.endereco}, n°{" "}
                                            {endereco.numero}
                                          </td>
                                          <td>{endereco.bairro}</td>
                                          <td>
                                            {endereco.cidade} -{" "}
                                            {endereco.estado}
                                          </td>
                                          <td className="text-center">
                                            <img
                                              className="img-responsive"
                                              src={"../../images/trash.svg"}
                                              alt="trash"
                                              style={{
                                                width: "20px",
                                                marginTop: "-4px",
                                              }}
                                              onClick={(e) =>
                                                this.removeEndereco(
                                                  endereco.sequencia
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>

                              {/* 
                                 
                                    <div className="form-group text-center">
                                      <button
                                        id="btn-prox"
                                        onClick={() => this.avancarAba('cliente')}
                                        style={{ marginBottom: "1%", marginLeft: "0.3%" }}
                                        className="btn btn-success pull-left"
                                      >
                                        Próximo
                                      </button>
                                    </div>
                                  */}
                              {/* <div className="form-group">
                                  <label>Principal: &nbsp;&nbsp;</label>
                                  <input
                                    type="checkbox"
                                    className=""
                                    checked={this.state.novoEndereco.principal}
                                    onChange={(e) =>
                                      this.setState({
                                        novoEndereco: {
                                          ...this.state.novoEndereco,
                                          principal: !this.state.novoEndereco.principal,
                                        },
                                      })
                                    }
                                  />
                                </div> */}
                            </div>
                          </React.Fragment>
                        </div>
                        <div
                          role="tabpanel"
                          className="tab-pane"
                          id="tab-contato"
                        >
                          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> novo com tabelas CONTATOS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/}
                          <React.Fragment>
                            <div
                              className="float-left width-100"
                              style={{ padding: "15px" }}
                            >
                              <div
                                className="container row"
                                style={{
                                  fontSize: "13.5px",
                                }}
                              >
                                {this.state.cliente.tipoPessoa === "PJ" && (
                                  <div
                                    className="col-5 float-left"
                                    style={{ padding: "4px" }}
                                  >
                                    <div className="form-group">
                                      <label>Nome do contato</label>
                                      <input
                                        type="text"
                                        value={this.state.novoContato.desc}
                                        onChange={(e) =>
                                          this.handleChangeInputNovoContato(
                                            e,
                                            "desc"
                                          )
                                        }
                                        className={`form-control font-size-13 ${
                                          this.state.errorsContato.desc
                                            ? "input-error"
                                            : ""
                                        }`}
                                      />
                                    </div>
                                  </div>
                                )}

                                {this.state.cliente.tipoPessoa === "PJ" && (
                                  <div
                                    className="col-2"
                                    style={{ padding: "4px" }}
                                  >
                                    <div className="form-group">
                                      <label>Tipo</label>
                                      <select
                                        className="form-control font-size-13"
                                        value={this.state.novoContato.padrao}
                                        onChange={(e) =>
                                          this.setState({
                                            novoContato: {
                                              ...this.state.novoContato,
                                              padrao:
                                                e.target.value === "true"
                                                  ? true
                                                  : false,
                                            },
                                          })
                                        }
                                      >
                                        <option value="true">Principal</option>
                                        <option value="false">
                                          Secundário
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                )}

                                <div
                                  className="float-left"
                                  style={{ padding: "4px", width: "15%" }}
                                >
                                  <div className="form-group">
                                    <label>Fone</label>
                                    <input
                                      type="text"
                                      value={this.state.novoContato.fone}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoContato(
                                          e,
                                          "fone"
                                        )
                                      }
                                      className={`form-control font-size-13 ${
                                        this.state.errorsContato.fone
                                          ? "input-error"
                                          : ""
                                      }`}
                                      disabled={
                                        this.state.cliente.tipoPessoa ===
                                          "PF" && this.state.contatos.length > 0
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="float-left"
                                  style={{ padding: "4px", width: "15%" }}
                                >
                                  <div className="form-group">
                                    <label>Celular</label>
                                    <input
                                      type="text"
                                      value={this.state.novoContato.cel}
                                      onChange={(e) =>
                                        this.handleChangeInputNovoContato(
                                          e,
                                          "cel"
                                        )
                                      }
                                      className={`form-control font-size-13`}
                                      disabled={
                                        this.state.cliente.tipoPessoa ===
                                          "PF" && this.state.contatos.length > 0
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="form-group col-4"
                                  style={{ padding: "4px" }}
                                >
                                  <label>Email</label>
                                  <input
                                    type="email"
                                    value={this.state.novoContato.email}
                                    onChange={(e) =>
                                      this.handleChangeInputNovoContato(
                                        e,
                                        "email"
                                      )
                                    }
                                    className={`form-control font-size-13 ${
                                      this.state.errorsContato.email
                                        ? "input-error"
                                        : ""
                                    }`}
                                    onBlur={(e) => {
                                      if (
                                        !validaEmail(
                                          this.state.novoContato.email
                                        )
                                      ) {
                                        this.notificar(
                                          "warning",
                                          "Email inválido."
                                        );
                                      }
                                    }}
                                    disabled={
                                      this.state.cliente.tipoPessoa === "PF" &&
                                      this.state.contatos.length > 0
                                        ? true
                                        : false
                                    }
                                  />
                                </div>

                                <div className="col-2 float-left pd-pedido">
                                  <div className="form-group">
                                    <button
                                      className="btn btn-success btn-app-pedidos-verde"
                                      style={{ marginTop: "28px" }}
                                      onClick={this.salvarContato}
                                    >
                                      Adicionar
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group col-12 pd-pedido">
                                {/* <button
                                  className="btn btn-secondary"
                                  onClick={() => this.avancarAba("cliente")}
                                  style={{ marginLeft: "-1%" }}
                                >
                                  Voltar
                                </button> */}
                                <button
                                  className="btn btn-success"
                                  onClick={() => this.avancarAba("contato")}
                                  //style={{ marginLeft: "1%" }}
                                >
                                  Próximo
                                </button>
                              </div>

                              <div
                                className="row"
                                style={{ padding: "0 15px" }}
                              >
                                <table className="table table-striped">
                                  <thead className="thead-dark">
                                    <tr>
                                      <th scope="col">Nome</th>
                                      <th scope="col">Tipo</th>
                                      <th scope="col">Fone</th>
                                      <th scope="col">Celular</th>
                                      <th scope="col">Email</th>
                                      <th scope="col" className="text-center">
                                        Ações
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.contatos.map((contato, key) => (
                                      <tr key={key}>
                                        <th scope="row">{contato.desc}</th>
                                        <td>
                                          {contato.padrao
                                            ? "(Principal)"
                                            : "Secundário"}{" "}
                                        </td>
                                        <td>{contato.fone}</td>
                                        <td>{contato.cel}</td>
                                        <td>{contato.email}</td>
                                        <td className="text-center">
                                          <img
                                            className="img-responsive"
                                            src={"../../images/trash.svg"}
                                            alt="trash"
                                            style={{
                                              width: "20px",
                                              marginTop: "-4px",
                                            }}
                                            onClick={(e) =>
                                              this.removeContato(
                                                contato.sequencia
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </React.Fragment>
                        </div>
                        <div role="tabpanel" className="tab-pane" id="tab-info">
                          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Tab de novos Info adicionais <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/}
                          <div className="width-100">
                            <div
                              className="container row"
                              style={{ fontSize: "13.5px", paddingTop: "10px" }}
                            >
                              <div className="form-group col-4">
                                <label>Condição de pagamento</label>
                                <AsyncSelect
                                  cacheOptions
                                  defaultOptions
                                  loadOptions={this.promiseOptionsCondPgto}
                                  value={this.state.condPagto}
                                  onChange={(item) =>
                                    this.handleChangeSelect(item, "condPagto")
                                  }
                                  placeholder="Selecione"
                                />
                              </div>

                              <div className="form-group col-4">
                                <label>Forma de pagamento</label>

                                <AsyncSelect
                                  cacheOptions
                                  defaultOptions
                                  loadOptions={this.promiseOptionsformaPagto}
                                  value={this.state.formaPagto}
                                  onChange={(item) =>
                                    this.handleChangeSelect(item, "formaPagto")
                                  }
                                  placeholder="Selecione"
                                />
                              </div>

                              {this.state.cliente.tipoPessoa === "PJ" && (
                                <div className="form-group col-3">
                                  <label>Regime Tributário</label>
                                  <select
                                    value={this.state.regimeTributario}
                                    onChange={(e) =>
                                      this.handleChangeSelect(
                                        e.target.value,
                                        "regimeTributario"
                                      )
                                    }
                                    className="form-control"
                                    style={{ fontSize: "13.5px" }}
                                  >
                                    <option value="Simples Nacional">
                                      Simples Nacional
                                    </option>
                                    <option value="Lucro Real">
                                      Lucro Real
                                    </option>
                                    <option value="Lucro Presumido">
                                      Lucro Presumido
                                    </option>
                                    <option value="Arbitrário">
                                      Arbitrário
                                    </option>
                                    <option value="Indefinido">
                                      Indefinido
                                    </option>
                                  </select>
                                </div>
                              )}

                              <div className="form-group col-11">
                                <label>Transportadora</label>

                                <AsyncSelect
                                  cacheOptions
                                  defaultOptions
                                  loadOptions={
                                    this.promiseOptionsTransportadora
                                  }
                                  value={this.state.transportadora}
                                  onChange={(item) =>
                                    this.handleChangeSelect(
                                      item,
                                      "transportadora"
                                    )
                                  }
                                  placeholder="Selecione"
                                />
                              </div>

                              <div className="form-group col-11">
                                <label>Observação:</label>
                                <textarea
                                  className="form-control font-size-13"
                                  value={this.state.obs}
                                  onChange={(e) =>
                                    this.handleChangeInputObs(e, "obs")
                                  }
                                >
                                  {this.state.obs}
                                </textarea>
                              </div>
                              <div className="form-group col-5 d-flex">
                                <button
                                  className="btn btn-success btn-app-pedidos"
                                  // onClick={() =>
                                  //   //this.cadastrarPedido("orcamento")
                                  // }
                                  onClick={this.gravarCliente}
                                  disabled={
                                    !this.state.validacao.cliente ||
                                    !this.state.validacao.contato ||
                                    !this.state.validacao.endereco
                                      ? true
                                      : false
                                  }
                                >
                                  Cadastrar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          role="tabpanel"
                          className="tab-pane"
                          id="tab-infoteste"
                        >
                          <div className="design-process-content">
                            <h3>Reporting</h3>
                            <p>
                              Lorem ipsum dolor sit amet, consectetuer
                              adipiscing elit, sed diam nonummy nibh euismod
                              tincid unt ut laoreet dolore magna aliquam erat
                              volutpat.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="push"></div>
                <div className="col-lg-12">
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default NewClient;
